import React from "react";
import { OptionsPositionTypes } from "src/components/DefaultColumnsList/Options/interface";
import { ITimelineDTO } from "src/components/TimelineVertical/interface";
import IBaseDTO from "src/Interfaces/baseDTO";
import IGroupersDTO from "src/Interfaces/groupersDTO";

interface IFiltersActionsPanel{
    f: string;
    responsible: string | undefined;
	authority: string | undefined;
    consulted: string | undefined;
    informed: string | undefined;
	sector: string | undefined;
    situation: {
        value: string;
        label: string;
    }[] | string | undefined;
    startDate?: Date | null;
    endDate?: Date | null;
    tags: string | undefined;
    map: string | undefined;
    perspective: string | undefined;
    objective: string | undefined;
    indicator: string | undefined;
    filterOrigin: string | undefined;
    percConclusion: number[];
    project: string | undefined;
    actionId?: string | null;
    notValidateRaci?: boolean;
}

export interface IListActions{
    inb001Id: number;
    inb001Codigo: string;
    inb001Titulo: string;
    inb001Exigeeficacia: "S" | "N";
    inb001Efa005Nome: string;
    inb001Efa005Imagem: string;
    inb001Efa005Nome2: string;
    inb001Efa005Imagem2: string;
    inb001PercConclusao: number;
    inb001Dtinicio: Date;
    inb001Dtfim: Date;
    daysCount: number;
    situation: string;
    inb003Dtfim?: Date | null;
    attachmentsNumber: number;
    commentsNumber: number;
    traceability: number;
    isSubaction: boolean;
    subactionsNumber: number;
    hasPostponement: boolean;
    hasCancel: boolean;
    efficiency: number;
    percentagePredicted: number;
    isTask: boolean;
    taskDuration: number | null;
    taskDurationRealized: number | null;
    inb001Efa005Id: number;
    inb001Efa005Id2: number;
    inb004Id?: number;
    inb004DataFinal?: Date | null;
    percentageColorConcluded: string;
}

export const createIGroupersActions = (data: IGroupersActions) : IGroupersActions => ({
	id: data.id,
	id2: data.id2 || null,
	id3: data.id3 || null,
	id4: data.id4 || null,
	title: data.title,
	title2: data.title2 || null,
	title3: data.title3 || null,
	title4: data.title4 || null,
	image: data.image || null,
	imageName: data.imageName || null,
	draft: data.draft || 0,
	notStarted: data.notStarted || 0,
	nextToExpire: data.nextToExpire || 0,
	delayed: data.delayed || 0,
	finished: data.finished || 0,
	canceled: data.canceled || 0,
	started: data.started || 0,
	percentage: data.percentage || 0,
	count: data.count || 0
});

export interface IGroupersActions extends IGroupersDTO<IGroupersActions>{
    id2: number | null;
    id3: number | null;
    id4: number | null;
    title2: string | null;
    title3: string | null;
    title4: string | null;
    image: string | null;
    imageName: string | null;

    draft: number;
    notStarted: number;
    nextToExpire: number;
    delayed: number;
    finished: number;
    canceled: number;
    started: number;

    percentage: number | null;
}

export interface ICheckListAction extends ITimelineDTO{
    sumWeight: number;
    sumWeightChecklist: number;
    weight: number;
    weightChecklist: number;
}

export interface IAction extends IBaseDTO{
    inb001Ina001Id: number | null;
    inb001Ina002Id: number | null;
    inb001Rib003Id: number | null;
    inb001Rib004Id: number | null;
    inb001Mea003Id: number | null;
    inb001Pra003Id: number | null;
    inb001Ocb001Id: number | null;
    
    attachmentsNumber: number;
    commentsNumber: number;
    inb001Id: number;
    inb001Codigo: number | string;
    inb001Titulo: string;
    inb001Situacao: number;
    inb001Dtinicio: Date;
    inb001Dtfim: Date;
    inb001Dtconclusao: Date | null;
    inb001Taa001Id: number;
    inb001Taa001Nome: string;
    inb001Efa004Id: number;
    inb001Efa004Nome: string;
    inb001Onde: string;
    inb001Como: string;
    inb001Motivo: string;
    inb001Urgencia: number | null;
    inb001Importancia: number | null;
    inb001Notificaautoridade: "N" | "S";
    inb001Notificaresponsavel: "N" | "S";
    inb001Tipo: 1 | 2;
    inb001Duracao: number;

    inb001Exigeeficacia: "N" | "S";
    inb001Diaseficacia: number;

    inb001Informavalores: number;
    inb001Valor: number | null;
    inb001Vlrrealizado: number | null;
    inb001Vlrliberado: number | null;
    inb001Vlrprevreceita: number | null;
    inb001Vlrrealreceita: number | null;

    inb001Efa005Id: number;
    inb001Efa005Id2: number;
    inb001Tags: string | string[] | null;

    intbb002: {
        inb002Efa004Id: number | null;
        inb002Efa004Nome: string;
        inb002Efa005Id: number | null;
        inb002Efa005Nome: string;
        inb002Id: number;
        inb002Notificaparticipante: "N" | "S";
        inb002Inb001Id: number;
        inb002Tipo: "I" | "C";
    }[];
    intbb009: {
        inb009Id: number;
        inb009Inb001Id: number;
        inb009Titulo: string;
        inb009Peso: number;
        intbb010: {
            inb010Id: number;
            inb010Inb009Id: number;
            inb010Item: string;
            inb010Verificado: "N" | "S";
            inb010Peso: number;
        }[];
    }[];
    intbb013: {
        year: string;
        data: string[][];
    }[];

    intbb003: {
        inb003Id: number;
        inb003Dtfim: Date;
        inb003Efa005Nome: string;
        inb003Efa005Imagem: string;
        inb003Justificativa: string;
    }[];

    traceability: {
        [key: string]: string;
    }

}


export interface Intbb004{
    inb004Id: number;
    inb004Data: Date | string;
    inb004Datafinal?: Date | string;
    inb004Descricao: string;
    inb004Duracao: number;
    inb004Vlrrealdespesa: number;
    inb004Vlrrealreceita: number;
    inb004Percconclusao: number;
}

interface IGroupersActionsList{
    grouperId: number; 
    grouperId2?: number | null; 
    grouperId3?: number | null; 
    grouperId4?: number | null;
}

export interface IListOfActions{
    layoutList: "card" | "list";

    groupers: IGroupersActionsList;
    groupersSelect: IGroupersActionsSelect;
    
    filters?: IFiltersActionsPanel;
    filterList?: ActionSituationFilter;

    header?: {
        showTotal?: boolean;
        button?: React.ReactNode;
    }

    positionOptions?: OptionsPositionTypes;

    onCallbackAdd?: Function;
    onCallbackUpdate?: Function;
    onCallbackDelete?: Function;

    layout?: "project" | "projectAgile" | "withProgressBarPredicted";

    callBackChangeActionSprint?: () => void;
    defaultActions?:IListActions[];
}

export interface IGrouperOfActions{
    layoutList: "card" | "list";
    grouper: IGroupersActions;
    onCallbackAdd: Function;
    groupersSelect: IGroupersActionsSelect;
    filters: IFiltersActionsPanel;
    header?: React.ReactNode; 
}

export interface IGroupersActionsSelect{
    group: ActionGroupers;
    origin: ActionTraceability | "";
    delayed: ActionDelayed | "";
}

export enum ActionType{
    ACTION = 1,
    TASK = 2
}

export enum ActionEfficiency{
    NOT_NEEDED = 0,
    NEEDED = 1,
    DELAYED = 2
}

export enum TabsActionMODAL {
	GENERAL = 0,
	RACI = 1,
	VALUES = 2,
	CHECKLISTS = 3,
    HISTORIC = 4,
    EFFICIENCY = 5,
    PROJECT = 6,
    TRACEABILITY = 7
}

export enum ActionSituation{
    NOT_STARTED = "0",
    IN_PROGRESS = "1",
    FINISHED = "2",
    CANCELED = "3",
    DRAFT = "4"
}

export enum ActionSituationFilter{
    DRAFT = "Rascunho",
    NOT_STARTED = "Não iniciada",
    IN_PROGRESS = "Em andamento",
    FINISHED = "Concluída",
    CANCELED = "Cancelada",
    NEXT_TO_EXPIRE = "A vencer em",
    DELAYED = "Atrasada"
}

export enum ActionTraceability{
    ACTION = "0",
    INICIATIVE_MAP = "1",
    FCA_INDICATOR = "2",
    MEETING = "3",
    PROJECT = "4",
    RISK = "5",
    OCCURRENCE = "6",
    INICIATIVE_OKR = "7"
}

export enum ActionInformValues{
    TOTAL = "1",
    MONTHLY = "2"
}

export enum RecurrenceType{
    DAILY = "1",
    WEEKLY = "2",
    MONTHLY = "3",
    ANNUAL = "4"
}

export enum ActionGroupers{
    SECTOR = "0",
    SECTOR_RAMMATRIX = "1",
    RAMMATRIX = "2",
    MAP = "3",
    MAP_INICIATIVE = "4",
    MAP_PERSPECTIVE_INICIATIVE = "5",
    MAP_PERSPECTIVE_OBJECTIVE_INICIATIVE = "6",
    SITUATION_MONTH = "7",
    INDICATOR_CLASSIFICATION = "8",
    INDICATOR = "9",
    INICIATIVE = "10",
    FCA = "11",
    RESPONSIBLE = "12",
    AUTHORITY = "13",
    MEETING = "14",
    PROGRAM = "15",
    PROGRAM_PROJECT = "16",
    PROGRAM_PROJECT_PHASE = "17",
    RISK = "18",
    FACT_CAUSE_OCCURENCE = "19",
    OCCURRENCE = "20",
    RISK_ANALYSIS = "21",
    OKR = "22",
    OKR_INICIATIVE = "23",
    OKR_KEYRESULTS_INICIATIVE = "24",
    ACTIONS_WITH_SUBACTIONS = "25",
    SITUATION = "26",
    ORIGIN = "27",
    KANBAN = "28",
    KANBAN_QUADRANT = "29",
    CALENDAR = "30",
    ACTIONS_IMMEDIATE_OCCURENCE = "31"
}

export enum ActionDelayed{
    YES = "1",
    NO = "0"
}

export interface IIntbb001BudgetGrouper{
    name: string;
    year: string;
    valueExpense: number;
    valueRealizedExpense: number;
    valueRevenue: number;
    valueRealizedRevenue: number;
    valueReleased: number;
}

export interface IChartYearGrouper{
    name: string;
    valueExpense: number;
    valueRealizedExpense: number;
    valueRevenue: number;
    valueRealizedRevenue: number;
    valueReleased: number;
}

export interface ITablesRelated{
    iniciativeId?: number;
    objectiveId?: number;
    factAndCause?: number;
    riskIncident?: number;
    riskAnalysis?: number;
    projectPhase?: number;
    occurrenceId?: number;
}

export interface IDateInitial{
    startDate: Date;
    endDate: Date;
}

export interface IRefActionsPanelModalAddChangeDelete{
    openModalAddOrChange: (id?: number, onCallback?: Function, tabInitSelected?: TabsActionMODAL | undefined, parentAction?: undefined | number, tablesRelated?: ITablesRelated, subtitle?: string, dateInitial?: IDateInitial, disabled?: boolean, copy?: boolean) => void;
    actionButtonDelete: (row: IListActions) => void;
}

export interface IRefActionsModalBudget{
    actionButtonOpenBudget: (grouperTitle: string, data: IIntbb001BudgetGrouper[]) => void;
}

export interface IRefActionsProgressModal{
    openModalChangeProgress: (id: number, subtitle: string, currentPercentage: number, onCallback?: Function, reopen?: boolean, onCallbackClose?: Function, isFinishing?: boolean) => void;
}

export interface IComponentActionsPanelModalAddChangeDelete{
    /**
     * (inb001Id: number, situation: string, percent: number) => void;
     */
    onCallbackDelete?: Function;
}

export interface IActionShowPostponementRef{
	openModalActionShowPostponements: (id: number, titleAction: string, defaultPostponement?: IPostponement[]) => void;
}


export interface IPostponement extends IBaseDTO{
	inb003Id: number;
	inb003Efa005Nome: string;
	inb003Efa005Imagem: string;
	inb003Dtfim: Date;
	inb003Justificativa: string;
    inb003Aprovada?: string;
}


export default IFiltersActionsPanel;
